var colTracker = [];
    /**
    * Set appropriate spanning to any masonry item
    *
    * Get different properties we already set for the masonry, calculate
    * height or spanning for any cell of the masonry grid based on its
    * content-wrapper's height, the (row) gap of the grid, and the size
    * of the implicit row tracks.
    *
    * @param item Object A brick/tile/cell inside the masonry
    */
    function resizeMasonryItem(grid, item, i){
      item.style.height = null;

      /* Get the row-gap, and the size of its implicit rows */
      var rowGap = parseInt(window.getComputedStyle(document.body).getPropertyValue('--grid-gap')),
          rowHeight = 10;

      grid.style.rowGap = 0;

      var colCount = colTracker.length;
      var colIndex = i % colCount;

      /* calculate row span */
      var rowSpan = Math.ceil((item.getBoundingClientRect().height)/(rowHeight));

      /* Set the spanning as calculated above (S) */
      //item.style.gridRowEnd = `span ${rowSpan}`;

      /* Make the item take all the available space in the cell */
      item.style.height = (rowSpan - 1) * rowHeight + "px";
      item.querySelectorAll(':scope > *').forEach((itemContent) => {
        itemContent.style.opacity = '1';
      });
      item.style.gridColumnStart = colIndex + 1;
      item.style.gridRowStart = colTracker[colIndex];

      var gridHeightToEnd = (colTracker[colIndex] + rowSpan - 2) * rowHeight;
      if (grid.dataset.height == undefined || gridHeightToEnd > grid.dataset.height) {
        grid.dataset.height = gridHeightToEnd;
        grid.style.gridTemplateRows = `repeat(${colTracker[colIndex] + rowSpan - 2}, ${rowHeight}px)`;
      }

      colTracker[colIndex] += rowSpan + Math.ceil(rowGap / rowHeight);
    }

    /**
    * Apply spanning to all the masonry items
    *
    * Loop through all the items and apply the spanning to them using
    * `resizeMasonryItem()` function.
    *
    * @uses resizeMasonryItem
    */
    function resizeAllMasonryItems(){
      colTracker = [];

      var grids = document.querySelectorAll('.article-grid');

      grids.forEach((grid) => {
        // Get all item class objects in one list
        var allItems = grid.querySelectorAll('.article-card');

        allItems.forEach((item) => {
          item.style.gridColumnStart = null;
          item.style.gridRowStart = null;
        });
        var colCount = window.getComputedStyle(grid).getPropertyValue("grid-template-columns").split(" ").length;

        for (let i = 0; i < colCount; i++) {
          colTracker.push(1);
        }

        /*
        * Loop through the above list and execute the spanning function to
        * each list-item (i.e. each masonry item)
        */
        allItems.forEach((item, i) => {
          resizeMasonryItem(grid, item, i);
        });
      });
    }

    /* Resize all the grid items on the load and resize events */
    var masonryEvents = ['DOMContentLoaded', 'load', 'resize', 'more-loaded'];
    masonryEvents.forEach( function(event) {
      window.addEventListener(event, resizeAllMasonryItems);
    } );
